import React from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Result } from 'antd';
const PageDoesnotExist = () => {
    const navigate = useNavigate();
    const redirectTo = "/";

  return (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={<Button type="primary" onClick={() => navigate(redirectTo)} >Back To HomePage</Button>}
  />
  )
};
export default PageDoesnotExist;